import { Injectable } from '@angular/core';
import { PaginatorResponse, ResponseData } from '@klickdata/core/http';
import { AppScope } from '@klickdata/core/resource';
import { TableHttpHelpers, TableHttpService, TableSource } from '@klickdata/core/table';
import { UserNotes, UserNotesData, UserNotesService } from '@klickdata/core/user-notes';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable()
export class UserNotesListingService extends UserNotesService implements TableHttpService<UserNotes> {
    public fetchData(source: TableSource<UserNotes>): Observable<ResponseData<UserNotes[]>> {
        const req = this.builder.get<UserNotesData[]>(this.notesUrl);
        req.param('scope', AppScope.RESOURCES);

        TableHttpHelpers.managePagination(source.paginator, req);
        TableHttpHelpers.manageSort(source.sort, req);
        TableHttpHelpers.mapFilter(source.filter, req);

        return req.request().pipe(
            map((res: PaginatorResponse<UserNotesData[]>) => {
                return {
                    data: res.data.map((userNotes) => this.mapUserNotes(userNotes)),
                    notify: res.notify,
                    more: res.more,
                    paginator: res.paginator,
                };
            })
        );
    }
}
